module.exports = __webpack_public_path__ + "img/shengwang.13ae7433.png";